import axios from "axios";
import Config from "../../utils/Config";
const BASE_URL = `${Config.baseUrl}api/`;

class SubscriptionRequests {
  getHeaders() {
    return {
      headers: {
        Authorization: `Bearer ${localStorage.getItem(
          "txtconnect_ng_user_token"
        )}`,
        "Content-Type": "application/json",
      },
    };
  }
//this is my latest comment
// lastttttt
  async initiateSubscriptionPayment(payload) {
    try {
      //console.log("🌐 [initiateSubscriptionPayment API] Calling payment endpoint with payload:", payload);
      const response = await axios.post(
        `${BASE_URL}user/payment`,
        payload,
        this.getHeaders()
      );
      //console.log("🌐 [initiateSubscriptionPayment API] Raw axios response:", response.data);
      
      if (response.data?.data) {
        const processedResponse = {
          status_code: response.data.data.status_code || "200",
          reason:
            response.data.data.reason ||
            response.data.data.message ||
            "Success",
          data: response.data.data.data || response.data.data,
        };
        //console.log("🌐 [initiateSubscriptionPayment API] Processed response:", processedResponse);
        return processedResponse;
      }
      
      // Fallback for different response structure
      const fallbackResponse = {
        status_code: "000",
        reason: "Success",
        data: response.data?.data || response.data,
      };
      //console.log("🌐 [initiateSubscriptionPayment API] Using fallback response:", fallbackResponse);
      return fallbackResponse;
    } catch (error) {
      console.error("❌ [initiateSubscriptionPayment API] Error:", error);
      return {
        status_code: "999",
        reason:
          error.response?.data?.message ||
          error.message ||
          "Failed to initiate payment",
        data: null,
      };
    }
  }

  async VerifySubscription(network = null, transactionId = null) {
    try {
      //console.log("🌐 [VerifySubscription API] Calling with:", { network, transactionId });
      const url = `${BASE_URL}user/payment/status_check`;
      const payload = {
        network: network,
        reference_id: transactionId,
      };
      const response = await axios.post(url, payload, this.getHeaders());
      //console.log("🌐 [VerifySubscription API] Raw response:", response.data);
      
      // Handle the actual response structure from your API
      const apiResponse = response.data?.data;
      
      if (apiResponse) {
        // console.log("📊 [VerifySubscription] Processing API response:", {
        //   statusCode: apiResponse.status_code,
        //   reason: apiResponse.reason,
        //   data: apiResponse.data
        // });
        
        // Return properly structured response
        return {
          status_code: apiResponse.status_code || "200", // API returns "200" for success
          reason: apiResponse.reason || "Status query successful",
          data: apiResponse.data || apiResponse, // Contains status field
        };
      }

      //console.log("response status_check:", response);
      
      // Fallback for different response structure
      return {
        status_code: response.data?.status_code || "200",
        reason: response.data?.reason || "Success",
        data: response.data?.data || response.data,
      };
    } catch (error) {
      console.error("❌ [VerifySubscription API] Error:", error);
      return {
        status_code: "999",
        reason: error.response?.data?.message || error.message || "Error verifying transaction",
        data: null,
      };
    }
  }

  async getCurrentUserSubscriptionData() {
    try {
      const response = await axios.get(
        `${BASE_URL}user/active_subscription`,
        this.getHeaders()
      );
      // API response: { data: { status_code, message, reason, data: { id, plan_name, units, subscription_plan, ... } } }
      const outer = response.data?.data;
      if (outer) {
        const status_code = outer.status_code || "000";
        const reason = outer.reason || outer.message || "Success";
        // Inner data is the user/subscription record (plan_name, units, subscription_plan, etc.)
        const userRecord = outer.data;
        const processedResponse = {
          status_code,
          reason,
          data: userRecord || outer,
        };
        return processedResponse;
      }

      // Fallback for different response structure
      return {
        status_code: "200",
        reason: "Success",
        data: response.data?.data || response.data,
      };
    } catch (error) {
      console.error("❌ [getCurrentUserSubscriptionData API] Error:", error);
      return {
        status_code: "999",
        reason:
          error.response?.data?.message || error.message || "Error fetching subscription data",
        data: null,
      };
    }
  }

  async getUnitsLeft() {
    try {
      const response = await axios.get(
        `${BASE_URL}user/check/sms_units`,
        this.getHeaders()
      );
      // API returns { data: userRecord } where userRecord has id, units, plan_name, subscription_plan, etc.
      const userRecord = response.data?.data;
      if (!userRecord) {
        return {
          status_code: "999",
          reason: "No data",
          data: null,
        };
      }
      return {
        status_code: userRecord.status_code ?? "000",
        reason: userRecord.reason ?? "Success",
        data: userRecord,
      };
    } catch (error) {
      return {
        status_code: "999",
        reason: error.response?.data?.message || "Error checking units left",
        data: null,
      };
    }
  }
}

const subscriptionRequests = new SubscriptionRequests();
export default subscriptionRequests;